if (!customElements.get('product-card')) {
  customElements.define(
    'product-card',
    // eslint-disable-next-line no-undef
    class ProductCard extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.initialize()

        const slide = this.querySelector(
          '[data-product-card-carousel-el="slide"]',
        )
        const alternatePublicId = slide?.dataset.darkModeMediaPublicId || null
        const alternateType = slide?.dataset.darkModeMediaType || null

        this.state = {
          isDarkMode: this.dataset.darkMode === 'true',
          currentMediaElement: slide?.lastElementChild || null,
          alternateMedia: {
            publicId: alternatePublicId,
            type: alternateType,
          },
        }

        this.context = this.dataset.context
      }

      initialize () {
        this._productOptionHTML = {}

        if (this.closest('.nosto_element')) {
          /* Execute for every product card within an element with the class `.nosto_element` */

          this.setupNosto()
        }
      }

      setupListeners () {
        super.setupListeners()

        if (!this.productHandle) return

        if (this.hasEl('quickBuyContainer')) {
          this.listeners.add(
            this,
            'mouseenter',
            this.handleDesktopHover.bind(this),
          )
        }

        if (this.hasEl('desktopTrigger')) {
          this.listeners.add(
            this.els.desktopTrigger.element,
            'click',
            this.handleDesktopTrigger.bind(this),
          )
        }

        if (this.hasEl('mobileTrigger')) {
          this.els.mobileTrigger.elements.forEach(mobileTrigger =>
            this.listeners.add(
              mobileTrigger,
              'click',
              this.handleMobileTrigger.bind(this),
            ),
          )
        }

        if (this.hasEl('quickbuyAddToCart')) {
          this.listeners.add(
            this.els.quickbuyAddToCart.element,
            'click',
            this.handleSubmit.bind(this),
          )
        }

        if (this.id) {
          this.listeners.add(
            this.els.link.element,
            'click',
            this.handleLinkClickWithID.bind(this),
          )
        }

        if (this.hasEl('wishlistButton')) {
          window.BAO.eventBus.addEventListener(
            window.BAO.EVENTS.PRODUCT.VARIANT_CHANGED,
            this.handleVariantChange.bind(this),
          )
          this.listeners.add(
            this.els.wishlistButton.element,
            'click',
            this.handleWishlistButtonClick.bind(this),
          )
        }

        if (
          this.pageTemplate === 'collection' ||
          this.pageTemplate === 'search'
        ) {
          this.listeners.add(this, 'click', this.setClickedProduct.bind(this))

          this.listeners.add(
            document,
            'DOMContentLoaded',
            this.scrollToCard.bind(this),
          )
        }

        window.addEventListener(
          'dark-mode-toggle',
          this.handleDarkModeToggle.bind(this),
        )
      }

      handleDarkModeToggle (event) {
        this.darkMode = event.detail.isDarkMode
      }

      renderDarkMode () {
        const slide = this.querySelector(
          '[data-product-card-carousel-el="slide"]',
        )
        if (!slide) return

        const hasAlternateElement = this.state.alternateMedia.element
        const hasAlternatePublicId = this.state.alternateMedia.publicId

        if (!hasAlternateElement && !hasAlternatePublicId) return

        const savedElement = this.state.currentMediaElement

        this.resetMedia(slide)

        if (hasAlternateElement) {
          slide.appendChild(this.state.alternateMedia.element)
        } else if (this.state.alternateMedia.type === 'video') {
          slide.insertAdjacentHTML(
            'beforeend',
            this.videoTemplate(this.state.alternateMedia.publicId),
          )
        } else if (this.state.alternateMedia.type === 'image') {
          slide.insertAdjacentHTML(
            'beforeend',
            this.imageTemplate(this.state.alternateMedia.publicId),
          )
        }

        this.state.currentMediaElement = slide.lastElementChild
        this.state.alternateMedia.element = savedElement
      }

      resetMedia (slide) {
        const link = slide.querySelector('a')
        slide.innerHTML = ''
        if (link) slide.appendChild(link)
      }

      updateSrcSet (img, src) {
        img.setAttribute('saved-src', img.src)
        img.src = src
      }

      videoTemplate (id) {
        return `
          <lazy-video class="prd-Card_DarkMedia">
            <video
              class="prd-Card_Player"
              autoplay
              loop
              muted
              playsinline
              poster="{{ main_media.preview_image | image_url: width: 680 }}"
            >
              <source data-src="https://assets.ohpolly.com/video/upload/c_scale,w_2000/f_auto:video,q_auto/${id}" type="video/mp4">
            </video>
          </lazy-video>
        `
      }

      imageTemplate (id, alt) {
        return `
          <img class="prd-Card_DarkMedia rsp-Image_Image" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
            srcset="https://assets.ohpolly.com/image/upload/t_web/c_scale,w_180/f_auto,q_auto/${id} 180w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_360/f_auto,q_auto/${id} 360w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_540/f_auto,q_auto/${id} 540w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_720/f_auto,q_auto/${id} 720w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_900/f_auto,q_auto/${id} 900w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_1080/f_auto,q_auto/${id} 1080w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_1296/f_auto,q_auto/${id} 1296w,
            https://assets.ohpolly.com/image/upload/t_web/c_scale,w_1512/f_auto,q_auto/${id} 1512w"
            alt="${alt}" loading="lazy" sizes="(max-width: 767px) 50vw, 33vw" width="900" height="1350"
          >
        `
      }

      handleSubmit (event) {
        const variantId = event.target.querySelector('[name="id"]').value

        window.BAO.dispatchEvent(
          window.BAO.EVENTS.ALGOLIA.AFTER_SEARCH_RESULTS_QUICK_ADD,
          {
            data: this.buildAlgoliaTrackingInformation(variantId),
          },
        )
      }

      buildAlgoliaTrackingInformation (variantId) {
        const algoliaParent = this.closest('.ais-hit')

        return {
          productId: algoliaParent.dataset.algoliaProductId,
          userToken: '',
          eventType: 'conversion',
          eventSubtype: 'addToCart',
          eventName: 'Added to cart',
          index: algoliaParent.dataset.algoliaIndex,
          queryID: algoliaParent.dataset.algoliaQueryid,
          objectIDs: [variantId || null],
          objectData: [
            {
              price: algoliaParent.dataset.algoliaPrice,
              quantity: 1,
            },
          ],
          currency: Shopify.currency.active,
        }
      }

      setupNosto () {
        if (window.Shopify.routes.root) {
          this.querySelectorAll('a').forEach(anchor => {
            if (anchor.href.includes('/products/')) {
              anchor.href = anchor.href.replace(
                '/products/',
                `${window.Shopify.routes.root}products/`,
              )
            }
          })
        }
      }

      handleVariantChange (event) {
        const wishlistButtonEls = [
          this.els?.wishlistButton?.element,
          this.externalEls?.wishlistButton?.element,
        ].filter(Boolean)

        wishlistButtonEls.forEach(wishlistButtonEl => {
          if (
            wishlistButtonEl.dataset.productId.toString() !==
            event.detail.product.id.toString()
          ) {
            return
          }
          wishlistButtonEl.setAttribute(
            'data-variant-id',
            event.detail.variant.id.toString(),
          )
          if (
            window.wishlistProducts &&
            Array.isArray(window.wishlistProducts)
          ) {
            const wishlistVariant = window.wishlistProducts.find(
              product =>
                product.epi.toString() === event.detail.variant.id.toString(),
            )
            wishlistButtonEl.setAttribute(
              'data-wishlist-status',
              wishlistVariant ? 'added' : '',
            )
          }
        })
      }

      /**
       * Handles the click event on a wishlist button, toggling items in the wishlist by adding or removing them based on their current status.
       *
       * @param {Event} event - The triggered click event object containing information about the event.
       */

      handleWishlistButtonClick (event) {
        const trigger = event.currentTarget

        if (trigger.dataset.wishlistStatus === 'added') {
          this.removeFromWishlist(trigger)
        } else {
          trigger.setAttribute('data-wishlist-status', 'loading')
          this.addToWishlist(trigger)
        }
      }

      handleSave (event) {
        sessionStorage.setItem('lastClickedProductCard', this.productHandle)
      }

      removeFromWishlist (wishlistButtonEl) {
        window._swat.removeFromWishList(
          {
            epi: parseInt(wishlistButtonEl.dataset.variantId, 10),
            du: `${wishlistButtonEl.dataset.productUrl}?variant=${wishlistButtonEl.dataset.variantId}`,
            empi: parseInt(wishlistButtonEl.dataset.productId, 10),
          },
          () => {
            wishlistButtonEl.removeAttribute('data-wishlist-status')
            window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.UPDATED, {
              eventType: 'remove_from_wishlist',
              productTitle: wishlistButtonEl.dataset.productTitle,
              productPrice:
                parseInt(wishlistButtonEl.dataset.productPrice) / 100,
              productId: wishlistButtonEl.dataset.productId,
            })
          },
        )
      }

      addToWishlist (wishlistButtonEl) {
        window._swat.addToWishList(
          {
            epi: parseInt(wishlistButtonEl.dataset.variantId, 10),
            du: `${wishlistButtonEl.dataset.productUrl}`,
            empi: parseInt(wishlistButtonEl.dataset.productId, 10),
          },
          () => {
            window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.UPDATED, {
              eventType: 'add_to_wishlist',
              productTitle: wishlistButtonEl.dataset.productTitle,
              productPrice:
                parseInt(wishlistButtonEl.dataset.productPrice) / 100,
              productId: wishlistButtonEl.dataset.productId,
            })
          },
        )
      }

      handleLinkClickWithID (event) {
        event.preventDefault()

        const queries = new URLSearchParams(window.location.search)
        queries.set('page', this.getAttribute('current-page'))
        this.updateURLHash(queries)

        window.location.hash = this.id

        const targetHref = event.target.href || event.target.closest('a')?.href
        window.location.href = targetHref
      }

      /**
       * @param {URLSearchParams} searchParams
       *
       * @returns {void}
       */
      updateURLHash (searchParams) {
        history.pushState(
          { searchParams: searchParams.toString() },
          '',
          `${window.location.pathname}${searchParams &&
            '?'.concat(searchParams.toString())}`,
        )
      }

      handleDesktopTrigger (event) {
        if (window.abTest576) return

        event.preventDefault()
        event.stopImmediatePropagation()

        const trigger =
          event.target.closest(this.els.desktopTrigger?.selector) ||
          event.target.closest(this.els.wishlistButton?.selector)
        if (!trigger) return
        const isNostoChild = event.currentTarget.closest('.nosto_element')
        let source = null

        /* Close open containers first */
        this.handleClose()

        if (!this.hasEl('quickBuyContainer')) return

        if (trigger.hasAttribute('data-buy-trigger')) {
          this.els.quickBuyContainer.element.setAttribute('data-mode', 'buy')
        }

        if (trigger.hasAttribute('data-wishlist-trigger')) {
          this.els.quickBuyContainer.element.setAttribute(
            'data-mode',
            'wishlist',
          )
        }

        if (isNostoChild) {
          const myEvent = new CustomEvent('nostoRecs::quickBuy', {
            detail: { event },
          })
          window.dispatchEvent(myEvent)

          source = isNostoChild?.id
        }

        sessionStorage.setItem(
          'BAO-gtm-quick-buy-form',
          trigger.closest('[data-gtm-section]')?.dataset.gtmSection,
        )

        this.renderProductForm(this.els.quickBuyContainer.element, source)
      }

      handleDesktopHover (event) {
        if (!window.abTest576) return
        if (this.rendered) return

        const isNostoChild = event.currentTarget.closest('.nosto_element')
        let source = null

        this.handleClose()

        if (!this.hasEl('quickBuyContainer')) return

        if (isNostoChild) {
          const myEvent = new CustomEvent('nostoRecs::quickBuy', {
            detail: { event },
          })
          window.dispatchEvent(myEvent)

          source = isNostoChild?.id
        }

        this.els.quickBuyContainer.element.classList.add('quick-buy-loaded')

        this.renderProductForm(this.els.quickBuyContainer.element, source)
      }

      handleMobileTrigger (event) {
        event.preventDefault()
        event.stopImmediatePropagation()

        document.body.classList.add('util-quick-buy-open')

        const trigger = event.target.closest(this.els.mobileTrigger.selector)
        const isNostoChild = event.currentTarget.closest('.nosto_element')
        let trackingInformation = null

        if (!trigger) return

        if (this.hasExternalEl('fixedBar')) {
          this.externalEls.fixedBar.element.setAttribute('aria-hidden', 'true')
        }

        if (isNostoChild) {
          const myEvent = new CustomEvent('nostoRecs::quickBuy', {
            detail: { event },
          })
          window.dispatchEvent(myEvent)
        }

        sessionStorage.setItem(
          'BAO-gtm-quick-buy-form',
          trigger.closest('[data-gtm-section]')?.dataset.gtmSection,
        )

        if (this.context === 'algolia') {
          trackingInformation = this.buildAlgoliaTrackingInformation()
        }

        window.BAO.dispatchEvent(window.BAO.EVENTS.MOBILE_QUICK_BUY.OPENED, {
          event,
          productHandle: this.productHandle,
          context: this.context,
          trackingInformation,
        })
      }

      handleClose (event) {
        if (event) {
          event.preventDefault()
          event.stopImmediatePropagation()
        }

        const quickBuyContainers = window.BAO.utils.getElements(
          this.els.quickBuyContainer.selector,
        )

        quickBuyContainers.forEach(quickBuyContainer => {
          quickBuyContainer.removeAttribute('data-mode')

          const productCard = quickBuyContainer.closest(this.tagName)
          if (productCard) {
            productCard.setAttribute('data-quick-buy-active', false)
          }

          if (!window.abTest576) {
            quickBuyContainer.setAttribute('aria-hidden', true)
          }
        })
      }

      async renderProductForm (quickBuyContainer, parentOfCard) {
        window.BAO.dispatchEvent(window.BAO.EVENTS.QUICKBUY.BEFORE_OPTIONS_LOAD)

        /* Set the state of the quickbuy container to busy so we can add custom styling */
        /* (Keep pointer events disabled while loading) */
        quickBuyContainer.setAttribute('aria-busy', true)

        /* Show the quickbuy container */
        quickBuyContainer.setAttribute('aria-hidden', false)

        /* Check if we already have the html - if not, request it */
        if (!this._productOptionHTML[this.productHandle]) {
          this._productOptionHTML[
            this.productHandle
          ] = await this.fetchProductOptionsHTML()
        }

        /* Inject the the option html into the quickbuy container */
        quickBuyContainer.innerHTML = this._productOptionHTML[
          this.productHandle
        ]

        if (parentOfCard) {
          quickBuyContainer.setAttribute('data-source', parentOfCard)
        }

        /* Change the state to no longer be busy */
        /* (Re enable pointer events) */
        quickBuyContainer.setAttribute('aria-busy', false)
        if (window.abTest576) {
          this.rendered = true
        }

        window.BAO.dispatchEvent(window.BAO.EVENTS.QUICKBUY.AFTER_OPTIONS_LOAD)

        if (this.context === 'algolia') {
          this.querySelector('form').addEventListener(
            'submit',
            this.handleSubmit.bind(this),
          )
        }
      }

      async fetchProductOptionsHTML () {
        /* Fetch the quickbuy section from the product page */
        return await fetch(
          `${window.Shopify.routes.root}products/${this.productHandle}?section_id=${this.quickbuySectionId}`,
        )
          .then(response => response.text())
          .then(responseText => {
            return responseText
          })
      }

      scrollToCard () {
        if ('scrollRestoration' in history) {
          history.scrollRestoration = 'manual'
        }

        const savedHandle = sessionStorage.getItem('BAO-PlpClickedProduct')

        if (!savedHandle) return

        const offsetTop = this.getOffsetTop(savedHandle)

        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        })

        sessionStorage.removeItem('BAO-PlpClickedProduct')
      }

      setClickedProduct (event) {
        const target = event.target.closest('[data-product-handle]')
        const productHandle = target?.getAttribute('data-product-handle')

        if (!productHandle) return

        sessionStorage.setItem('BAO-PlpClickedProduct', productHandle)
      }

      getOffsetTop (handle) {
        const targetElement = document.querySelector(
          `[data-product-handle="${handle}"]`,
        )
        const headerWrapper = document.querySelector(
          '[data-scroll-restore-external-el="header"]',
        )
        const announcementBar = document.querySelector(
          '[data-scroll-restore-external-el="announcementBar"]',
        )
        const searchBar = document.querySelector(
          '[data-scroll-restore-external-el="search"]',
        )
        const filterBar = document.querySelector(
          '[data-scroll-restore-external-el="filterBar"]',
        )

        const headerOffset = headerWrapper ? headerWrapper.offsetHeight : 0
        const searchBarOffset = searchBar ? searchBar.offsetHeight : 0
        const announcementBarOffset = announcementBar
          ? announcementBar.offsetHeight
          : 0
        const filterBarOffset = filterBar ? filterBar.offsetHeight : 0
        const targetElementOffset = targetElement
          ? targetElement.getBoundingClientRect().top
          : 0

        return (
          targetElementOffset +
          window.scrollY -
          headerOffset -
          searchBarOffset -
          announcementBarOffset -
          filterBarOffset
        )
      }

      hasEl (elementName) {
        return this.els[elementName] && this.els[elementName].exists
      }

      hasExternalEl (elementName) {
        return (
          this.externalEls[elementName] && this.externalEls[elementName].exists
        )
      }

      get productHandle () {
        return this.dataset.productHandle ? this.dataset.productHandle : null
      }

      get quickbuySectionId () {
        return 'product-quickbuy'
      }

      get externalWishlistButtonSelector () {
        if (!window.abTest576) {
          return '[data-product-card-external-el="wishlistButton"]'
        }
      }

      get pageTemplate () {
        const templateClass = [...document.body.classList].filter(className =>
          className.startsWith('template-'),
        )[0]

        const template = templateClass.split('template-')[1]

        return template || null
      }

      get darkMode () {
        return this.state.isDarkMode
      }

      set darkMode (value) {
        this.state.isDarkMode = value
        this.renderDarkMode()
        this.setAttribute('data-dark-mode', value)
      }
    },
  )
}
